import styled, { css } from 'styled-components'
import SubNav from 'components/SubNav'

export default styled.nav`
  display: flex;
  flex-flow: row nowrap;
  z-index: 100 !important;

  justify-content: space-between;
  align-items: flex-end;

  position: fixed;
  bottom: 0;
  left: 0;

  padding: 20px;

  z-index: 10;

  ${props => props.column && css`
    flex-flow: column nowrap;
  `}

  width: 100%;

  > *:last-child {
    margin-right: 0;
  }

  ${props => props.column && css`
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: flex-end;
    > * {
      margin-top: 2em;
    }

  `}

  @media (min-width: ${props => props.theme.small}) {
    justify-content: flex-start;
  }

  // a {
  //
  //     &:hover {
  //       direction: rtl !important;
  //       unicode-bidi: bidi-override;
  //     }
  // }
`



// WEBPACK FOOTER //
// ./src/components/MainNav.js